import apiFetch from '@wordpress/api-fetch';
import { useLocationStore } from '../state/storeLocation';
import { InputAndSelectSchemaValid } from '../validations/locationIsValid';
import { toast } from 'sonner';
import { useRefreshMetaData } from './useRefreshMetaData';
import { useConditional } from '../state/storeConditional ';
import { useTranslationStore } from '../state/useTranslationStore';
import { UseEndPoints } from './api/endpoints';

export const usePostMeta = () => {
	const {updateIsReadyGenerator, updateIsReadyToPost } = useConditional();
	const {getPrayerSettingMeta} = useRefreshMetaData()
	const { fetchTranslations } = useTranslationStore();
	const updateOnSelected = useLocationStore(
		( state ) => state.updateOnSelected
	);

	const endpoint = UseEndPoints();

	const appendDataPost = ( meta: InputAndSelectSchemaValid ) => {
		apiFetch( {
			path: endpoint + '/fp_prayersettings_meta',
			method: 'POST',

			data: {
				meta: meta.meta,
				value: meta.value,
				// ..other data, if any..
			},
		} )
			.then( ( post ) => {
				// console.log( '❤', post );
				toast.success( ` new data saved 😁 ${ meta.meta }` );
				
				updateOnSelected( {
					name: meta.meta,
				} );

				// this is for updating the custom location when you return to the PrayerSetting page
				getPrayerSettingMeta();
				updateIsReadyGenerator( false );
				updateIsReadyToPost( false );
				fetchTranslations();
				
			} )
			.catch( ( err ) => console.log( '💋', err ) );
	};

	return { appendDataPost };
};
